import { CircleAlert, type LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

/**
 * The two empty states and the failure state of a list (FR-UX-4, the approved «Stati» board): an
 * icon, one line saying what is true, one saying what to do, and the one action that does it.
 * First use and no results are different messages on purpose — "nobody yet" asks you to invite,
 * "nobody matches" asks you to search differently.
 */
export function StateMessage({
  icon: Icon,
  title,
  text,
  action,
  tone = 'neutral',
  role,
}: {
  readonly icon: LucideIcon;
  readonly title: string;
  readonly text?: string;
  readonly action?: ReactNode;
  readonly tone?: 'neutral' | 'error';
  readonly role?: 'alert' | 'status';
}) {
  const Shown = tone === 'error' ? CircleAlert : Icon;
  return (
    <div role={role} className="state-message">
      <span
        aria-hidden="true"
        className={cn('state-message-icon', tone === 'error' && 'state-message-icon-error')}
      >
        <Shown className="size-6" />
      </span>
      <p className="text-foreground text-base font-semibold">{title}</p>
      {text !== undefined ? (
        <p className="text-muted-foreground max-w-[360px] text-sm">{text}</p>
      ) : null}
      {action !== undefined ? <div className="mt-2">{action}</div> : null}
    </div>
  );
}
